<template>
	<div class="hundred">
		<div class="order-listing" v-for = "(dayOrders, date) in sortedOrders" v-if = "filterDate(date, dayOrders)">
			<h1 class = "mb1">{{date}}, {{$parent.weekdays[new Date(date+' '+new Date().getFullYear()).getDay()]}} </h1>
			<div :class="{'order': true, 'mb2': true, 'green': order.Redeemed, 'red': order.Status === 'Error', 'blue': !order.Redeemed && order.Status !== 'Error'}" v-for = "order in dayOrders" v-if = "filterItem(order, $parent.searchTerm)">
				<div class="order-head fz-16">
					<div class="fz-14">
						Order 
						<br>No.	
					</div>
					<div class="bold">
						{{order["Order ID"]}}
					</div>
					<div class="separator"></div>
					<div class="bold">{{copywriting[language][order["Collection Mode"] || "Pickup"]}}</div>
					<div class="separator"></div>
					<div class="bold text-right">
						{{$parent.formatTimeComplex(order)}}
					</div>
				</div>
				<div class="order-content fz-14">
					<strong>{{order.Name}} ( <a class="fz-18" :href="'tel:' + order['Contact Number']">{{order["Contact Number"]}}</a> )</strong>
					<br>
					<div class="address" v-if = "order['Collection Mode'] === 'Delivery'">
						House / Block / Unit No.: {{order["House Number"]}}
						<br>
						{{order["Address"]}}
					</div>
					<div class="email">
						{{order["Email"]}}
					</div>
					<div class="email" v-if = "order['Collection Mode'] === 'Dine In'">
						{{order["nPax"]}} Pax
					</div>
					<div class="email" style="word-break:break-all;" v-if = "order.Remarks">
						Remarks: {{order["Remarks"]}}
					</div>
					<template v-if = "order['Collection Mode'] === 'Delivery'">
						<div class="divider"></div>
						Delivery By:
						<br>
						<div class="delivery-type">
							{{order["Delivery Mode"]}} (Hotline: <a :href="'tel' + $parent.phoneNums[order['Delivery Mode']]">{{$parent.phoneNums[order['Delivery Mode']]}}</a>)
						</div>
						<template v-if = "order['Delivery Info'] != undefined">
							<div class="delivery-status">
								<div class="status yellow ib mr5"></div><div class="ib">{{order["Delivery Info"]["Status"]}} (Delivery Order No. {{order["Delivery Info"]["Delivery ID"]}})</div>
							</div>
							<div class="driver">
								<strong>Rider/Driver: {{order["Delivery Info"]["dName"]}} (<a class="fz-18" :href="'tel:' + order['Delivery Info']['dContact Number']">{{order["Delivery Info"]["dContact Number"]}}</a>)</strong>
							</div>
						</template>
					</template>
					<div class="divider"></div>
					<div class="order-summary fz-16">
						<table class="full">
							<tr>
								<td>
									<strong>Order Summary</strong>
								</td>
								<td>
									<strong>Qty</strong>
								</td>
								<td class="text-right"></td>
							</tr>
							<tr v-for = "item in order.Items">
								<td>
									{{item.Name}}
									<div class="options" v-html = "generateHTML(item)">

									</div>
								</td>
								<td>
									x {{item.Quantity}}
								</td>
								<td class="text-right">
									{{formatPrice(item['Total'] || item.Quantity*item.Price, "")}}
								</td>
							</tr>
							<!-- SPACING -->
							<tr>
								<td class="">
									<br><br><br>
								</td>
							</tr>
							<!-- SPACING END -->
							<tr v-if = "order['Collection Mode'] === 'Delivery'">
								<td class="text-right" colspan="2">
									{{copywriting[language]['Delivery Fee']}}:
								</td>
								<td class='text-right'>
									{{formatPrice(order["Delivery Fee"] || 0)}}
								</td>
							</tr>
							<tr v-for = "c in order.Commissions">
								<td class="text-right" colspan="2">
									{{c["Commission Name"]}}:
								</td>
								<td class='text-right'>
									{{formatPrice(c.Total || 0)}}
								</td>
							</tr>
							<tr v-if = "order['Promo Discount'] > 0">
								<td class="text-right" colspan="2">
									{{copywriting[language]['Promo Code']}}:
									<br>
									({{order["PromoCode"]}})
								</td>
								<td class='text-right'>
									{{formatPrice(order['Promo Discount'] || 0)}}
								</td>
							</tr>
							<tr>
								<td class="text-right bold" colspan="2">
									Total:
								</td>
								<td class='text-right bold'>
									{{formatPrice(order["Total"] || 0)}}
								</td>
							</tr>
							<tr>
								<td colspan="3" class="order-receive">
									Order Received: [{{formatDate(order["Date Created"])}}] [{{formatTime(order["Date Created"])}}]
								</td>
							</tr>
						</table>
					</div>
				</div>
				<div class="order-footer">
					<div class="text-left">
						<div class="btn-order-footer btn-error" @click = "setError(order)">
							Error
						</div>
					</div>
					<div class="text-right"@click = "redeem(order)">
						<div class="btn-order-footer btn-done" >
							Done
						</div>
					</div>
					<div class="clr"></div>
				</div>
			</div>
		</div>

		<div class="mgt-15 text-right" @click = "getMoreOrders" v-if = "!noNewOrders">
			<div class="sy-ms-btn bp-set">Load More</div>
		</div>
	</div>
</template>
<script>
var dbPath;
export default{
	data(){
		return{
			copywriting: copywriting,
			language: this.$store.getters.getLanguage(),
			orders: [],
			sortedOrders: {},
			todayOrders: [],
			searching: false,
			orderID: "",

			searchedOrder: {},
			nOrders: 10,
			noNewOrders: false,
			todayTime: new Date(myDate.displayCurrentDate({sequence: "y/m/d"}) + " 00:00:00").getTime(),
			lastSnapshot: null
		}
	},
	firestore(){
		dbPath = "business/" + this.$route.params.businessID + "/preorders";
		var today = new Date();
		today.setSeconds(0);
		today.setMinutes(0);
		today.setHours(0);
		this.getOrders();
		customJS.runAll();
		myFB.getCol(dbPath).orderBy("Date", "desc").where("Paid","==",true).where("Date","<=",new Date("2021-02-11 23:59:59").getTime()).where("Date",">=",new Date("2021-02-11 00:00:00").getTime()).get().then(r=>{
			console.log(r.docs.map(doc=> doc.data()).find(doc=> doc["Order ID"] === "A-933"))
		})
	},
	watch:{
		orders: function(){
			this.sortOrders();
		},
	},
	methods:{
		generateHTML(item){
			var i = myCopier.copy(item);
			var code = "";
			if (item.custom != undefined && item.custom.length > 0){
				code += "<div style = \"padding-left: 5px;\">\n";
				item.custom.forEach((c, cIndex)=>{
					code += (cIndex+1) + ": \n";
					code += "<div style = \"padding-left: 5px;\">\n";
					for (var optionIndex in c){
						var option = c[optionIndex];
						if (option.length > 0){
							code += "<li>- " + optionIndex + ": \n";
							option.forEach((choice, choiceIndex)=>{
								code += "<span>\n" + choice + "\n";
								if (choiceIndex < option.length-1){
									code += "<span>, </span>\n";
								}
								code += "</span>\n";
							});
							code += "</li>\n";
						}
					}
					code += "</div>\n"
				})
				code += "</div>\n";
			}
			return code;
		},
		//------------------------ DISPLAY ------------------------//
		formatTime(input){
			return myDate.displayDateTime(input,
			{
				sequence: "d-m-y",
			},
			{
				hourFormat: 12,
				sequence: "hh:mm",
			})
		},
		calcTotal(items){
			// console.log(items);
			var total = 0;
			items.forEach(i=>{
				// console.log(i);
				total += i.Quantity*i.Price;
			})
			// var Tax = total*0.06;
			// this.Total = total + Tax;
			this.Total = total;
			return this.Total;
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},


		//------------------------ SORTING ------------------------//
		getOrders(){
			myFB.db.collection(dbPath).orderBy("Date", "desc").where("Paid","==",true).where("Date","<=",this.todayTime).limit(this.nOrders).get().then(r=>{
				var allOrders = [];
				r.docs.forEach(d=>{
					allOrders.push(d.data());
				})
				this.lastSnapshot = r.docs[r.docs.length - 1];
				this.orders = allOrders;
				this.sortOrders();
				customJS.runAll();

				if (r.docs.length < this.nOrders){
					this.noNewOrders = true;
				}
			})
			// var allOrders = [];
			// for (var i = 0; i < this.nOrders; i++){
			// 	if (i < this.$parent.allOrders.length && this.$parent.allOrders[i].Redeemed){
			// 		allOrders.push(this.$parent.allOrders[i])
			// 	}
			// }
			// this.orders = allOrders;
		},
		getMoreOrders(){
			myFB.db.collection(dbPath).orderBy("Date", "desc").where("Paid","==",true).startAfter(this.lastSnapshot).limit(this.nOrders).get().then(r=>{
				var allOrders = [];
				this.orders.forEach(d=>{
					allOrders.push(d);
				})
				r.docs.forEach(d=>{
					if (!allOrders.map(o=> o.ID).includes(d.id)){
						allOrders.push(d.data());
					}
				})

				this.orders = allOrders
				this.lastSnapshot = r.docs[r.docs.length - 1];
				this.sortOrders();

				if (r.docs.length < this.nOrders){
					this.noNewOrders = true;
				}
			})
			// this.nOrders += 10;
			// var allOrders = [];
			// for (var i = 0; i < this.nOrders; i++){
			// 	if (i < this.$parent.allOrders.length && this.$parent.allOrders[i].Redeemed){
			// 		allOrders.push(this.$parent.allOrders[i])
			// 	}
			// }
			// if (allOrders.length == this.orders.length){
			// 	this.noNewOrders = true;
			// }
			// this.orders = allOrders;
		},
		sortOrders(){
			var today = new Date();
			today.setSeconds(0);
			today.setMinutes(0);
			today.setHours(0);
			var todayTime = today.getTime();

			var sortedOrders = {}
			var dateNow = "";

			this.orders.forEach(r=>{
				if (r["Collection Mode"] === "Purchase"){
					dateNow = myDate.displayDate(r["Date Created"],{sequence: "d m", monthMode: 2})
				}
				else{
					dateNow = myDate.displayDate(r.Date,{sequence: "d m", monthMode: 2})
				}
				if (sortedOrders[dateNow] == undefined){
					sortedOrders[dateNow] = [r];
				}
				else{
					sortedOrders[dateNow].push(r);
				}
			})
			this.sortedOrders = sortedOrders;
		},
		redeem(item){
			myFB.db.collection("orders").doc(item.ID).update({
				Redeemed: !item.Redeemed
			})
		},
		deleteOrder(item){
			if (confirm("Confirm deleting order " + item["Order ID"] + " for " + item.Name + "?")){
				myFB.deleteDoc("orders", item['.key'], this, "Deleting order " + item["Order ID"] + " for " + item.Name + "...", "Order deleted!");
			}
		},

		search(orderID){
			myFB.db.collection("orders").where("Order ID", "==", orderID).get().then(r=>{
				var  dateNow = myDate.displayDate(r.docs[0].data().Date,{
					separator: "-",
					sequence: "ddmmyyyy",
					monthMode: 2,
					showDate: 1,
					showMonth: 1,
					showYear: 1,
				})
				var searchedOrder = {};
				searchedOrder[dateNow] = [r.docs[0].data()];
				this.searchedOrder = searchedOrder
				this.searching = true;
			})
		},
		back(){
			this.searching = false;
			this.orderID = "";
		},
		calcNOrders(sOrders){
			var num = 0;
			for (var item in sOrders){
				num += sOrders[item].length;
			}
			return num;
		},

		//------------------------ DISPLAY ------------------------//
		formatTimeComplex(input){
			if (["Delivery", "Dine In"].includes(input["Collection Mode"])){
				return myDate.displayTime(input.Date,
				{
					hourFormat: 12,
					sequence: "hh:mm",
				}) + " - " + myDate.displayTime(input.Date + 60*60*1000,
				{
					hourFormat: 12,
					sequence: "hh:mm",
				})
			}
			else{
				return myDate.displayTime(input.Date,
				{
					hourFormat: 12,
					sequence: "hh:mm",
				})
			}
		},
		formatTime(input){
			return myDate.displayTime(input,
			{
				hourFormat: 12,
				sequence: "hh:mm",
			})
		},
		formatDate(input){
			return myDate.displayDate(input,
			{
				sequence: "d-m-y",
			})
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		filterDate(date, orders){
			return orders.some(r=>{
				return this.filterItem(r, this.$parent.searchTerm);
			})
		},
		filterItem(order, text){
			var filter = text.toUpperCase();
			var name = (order["Name"]).toString().toUpperCase().includes(filter);
			var email = (order["Email"]).toString().toUpperCase().includes(filter);
			var contactnumber = (order["Contact Number"]).toString().toUpperCase().includes(filter);
			var oID = (order["Order ID"]).toString().toUpperCase().includes(filter);
			var total = (order["Total"]).toString().toUpperCase().includes(filter);
			var remarks = (order["Remarks"]).toString().toUpperCase().includes(filter);
			var showCond = (name || oID || email || contactnumber || total  || remarks);
			return showCond;
		},

	}
};
</script>


// WEBPACK FOOTER //
// src/components/HistoryComp.vue